package org.catharsis.spendtel.core.impl

import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow
import org.catharsis.spendtel.core.api.PreferencesManager

class WebPreferencesManagerImpl : PreferencesManager {
    private val firstTimeOnGroupDetailsState = MutableStateFlow(true)
    private val firstTimeOnHomeScreenState = MutableStateFlow(true)
    private val hasViewedHowItWorksScreenState = MutableStateFlow(false)

    override val isFirstTimeOnGroupDetails: Flow<Boolean> = firstTimeOnGroupDetailsState.asStateFlow()

    override suspend fun setFirstTimeOnGroupDetails(isFirstTime: Boolean) {
        firstTimeOnGroupDetailsState.value = isFirstTime
    }

    override val isFirstTimeOnHomeScreen: Flow<Boolean> = firstTimeOnHomeScreenState.asStateFlow()

    override suspend fun setFirstTimeOnHomeScreen(isFirstTime: Boolean) {
        firstTimeOnHomeScreenState.value = isFirstTime
    }

    override val hasViewedHowItWorksScreen: Flow<Boolean> = hasViewedHowItWorksScreenState.asStateFlow()

    override suspend fun setHasViewedHowItWorksScreen(hasViewed: Boolean) {
        hasViewedHowItWorksScreenState.value = hasViewed
    }

    override suspend fun clearAllPreferences() {
        firstTimeOnGroupDetailsState.value = true
        firstTimeOnHomeScreenState.value = true
        hasViewedHowItWorksScreenState.value = false
    }

    override suspend fun resetFirstTimeOnGroupDetails() {
        setFirstTimeOnGroupDetails(true)
    }
}
